import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_4 = {
  key: 2,
  class: "w-full flex items-center justify-items-center"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"color":"#00d1c7ff !important"} }

import { computed, defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { transformDate, transformDate2, getGroupListByFactory, getRealFactoryIdList, transformBeiJingDate, transformLocalDate } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import DiagnosticReportDetails from "./common/DiagnosticReportDetails2.vue";
import { Dayjs } from 'dayjs';
import { langList } from "../../common/lang";
import { getGroupName } from "../../common/tools";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate"
import { message } from 'ant-design-vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'DiagnosticReport',
  setup(__props) {

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang();
let getDiagLang = (diagnosticNotes:any) => {
    try{
        let list1 = diagnosticNotes.split("；").filter((p:any) => p)
        let content = ''
        for(let d of list1) {
            let s1 = d.split("存在异常特征，判断为");
            let s1_1 = getTranslation(s1[0]);
            let s2 = s1[1].split('，');
            let s2_1 = getLanguage(s2[0]);

            let s3 = ''
            if(s2.length === 3) {
                s3 = '，' + s2[1] + '，' + s2[2]
            } else {
                s3 = '，' + s2[1]
            }
            if(language.value === 'English') {
                s3 = s3.replace("无设备故障，可持续运行", "there is no equipment failure and it can operate continuously")
                s3 = s3.replace("请关注设备分数变化情况", "please pay attention to the changes in the device scores")
                s3 = s3.replace("请关注设备状态与分数变化情况", "please pay attention to the status of the equipment and the changes in scores")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查", "please pay close attention to the status of the equipment and the changes in scores, and arrange inspections in a timely manner based on the on-site situation")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检修", "please pay close attention to the status of the equipment and the changes in the score, and arrange maintenance in a timely manner in combination with the on-site situation")
                s3 = s3.replace("建议停机维护", "it is suggested to shut down for maintenance")
            }

            content = content + s1_1 + getLanguage("存在异常特征，判断为")+ s2_1 + s3
        }
        return content
    } catch(err:any) {
        return diagnosticNotes
    }
    
};
const columns = [
    {
        title: langObj.value['更新时间'],
        dataIndex: 'date',
    },
    {
        title: langObj.value['设备区域'],
        dataIndex: 'groupName',
    },
    {
        title: langObj.value['设备名称'],
        dataIndex: 'machineName',
    },
    {
        title: langObj.value['严重程度'],
        dataIndex: 'gradeText',
    },
    {
        title: langObj.value['故障模式'],
        dataIndex: 'faultEvents',
    },
    {
        title: langObj.value['诊断描述'],
        dataIndex: 'content',
    },
    {
        title: langObj.value['操作'],
        dataIndex: 'act',
    },
]

let gradeList = [
  { value: -1, label: "健康", color: '#61c08f' },
  { value: 0, label: "可用", color: '#706a00ff' },
  { value: 1, label: "警戒", color: '#cd5f3b' },
  { value: 2, label: "故障", color: '#921e37' },
];

const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));

let searchModel:any = ref({
    groupId: null,
    machineId: null,
    keyword: '',
    date: null,
    total: 0,
    skip: 1,
    take: 10,
    sort: 'date',
    grade:null,
    order: -1
})
let data:any = ref([])
let groupList:any = ref([])
let machineList:any = ref([])
let visible = ref(false)
let reportId = ref('')
let mrDref = ref()

const getRowClassName = (record:any, index:any) => {
    // 根据索引设置不同的类名
    return index % 2 === 0 ? 'odd-row' : 'even-row';
}

onMounted(() => {
    init()
})

const init = () => {
    getAdmin()
    getGroupList()
    search()
}
let admin = ref(false)
const getAdmin = () => {
    let member = JSON.parse(localStorage.getItem('memberInfo') || '')
    admin.value = member?.admin
}

// 获取区域列表
const getGroupList = () => {
    groupList.value = getGroupListByFactory()
}

// 选择区域
const selectGroup = (ev:any) => {
    let memberInfo = JSON.parse( localStorage.getItem('memberInfo') || '')
    searchModel.value.machineId = ''
    if(ev) {
        machineList.value = memberInfo.machines.filter((p:any) => p.groupId === ev)
    } else {
        machineList.value = []
    }
}

const search = () => {
    searchModel.value.skip = 1
    getData()
}

const reset = () => {
    searchModel.value = {
        ...searchModel.value,
        grade:null,
        groupId: null,
        machineId: null,
        keyword: '',
        date: null,
    }
}

// 获取数据
const getData = async() => {
    let config: any = {
        params: {
            skip: searchModel.value.skip,
            take: searchModel.value.take,
            type: [1],
            keyword: searchModel.value.keyword,
            sort: searchModel.value.sort,
            order: searchModel.value.order,
            machineId: searchModel.value.machineId,
            factoryIds: getRealFactoryIdList(),
            grade:searchModel.value.grade,
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    if (searchModel.value.date && searchModel.value.date.length === 2) {
        config.params.begin = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[0]), 1));
        config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
    }

    let result = await request.get('/api/external/reports', config)

    if(result && result.status === 200) {
        let member = JSON.parse(localStorage.getItem('memberInfo') || '')
        result.data.list.forEach((element: any) => {
            if (element.expertReport) {
            element.expertReport.faultCause = element.expertReport.faultCause
                ? element.expertReport.faultCause.replace(/\n/g, "<br>")
                : "";
            element.gradeText = element.expertReport.grade

            let faultEvents = ''
            element.expertReport.diagnosisDetails.forEach((item2: any, index2:any) => {
                var grade = gradeList.find((t) => t.value == item2.grade);
                item2.gradeText = grade ? grade.label : "";
                if(language.value==='Chinese_ft') {
                    faultEvents = faultEvents + getChineseFt(item2.faultEvent)
                } else {
                    faultEvents = faultEvents + langObj.value[item2.faultEvent]
                }
                
            });

            element.faultEvents = faultEvents
            }
            if (element.machines && element.machines[0]) {
            element.machineName = element.machines[0].machineName;
            // element.groupName = member.groups.find((p:any) => p.id === element.machines[0].groupId)?.name
            element.groupName = getGroupName(element.machines[0]?.groupId)
            }
        });

        data.value = result.data.list
        searchModel.value.total = result.data.count
    }
}

const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // 处理分页数据
  if(Object.keys(sorter).length) { 
    var order = sorter.order ? (sorter.order == "descend" ? -1 : 1) : 0;
    searchModel.value.sort = sorter.field
    searchModel.value.order = order
  }
  // 处理分页数据
  searchModel.value.skip = pagination.current
  searchModel.value.take = pagination.pageSize
  getData();
};

const details = (ev:any) => {
    visible.value = true
    reportId.value = ev.id
    setTimeout(() => {
        mrDref.value.show(ev.id)
    }, 500);
}

const cancel = (ev:any) => {
    if(ev) {
        visible.value = false
        reportId.value = ''
    }
}

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};

const deleteReport = async(ev:any) => {
    const config = {
        params: {
            id: ev.id
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.delete('/api/reports/info', config)
    if (result?.data) {
        message.success(getLanguage("操作成功"));
        getData();
    } else {
        message.warning("操作失败");
    }
}



return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_form, {
        model: _unref(searchModel),
        name: "horizontal_login",
        layout: "inline",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['设备区域'],
            name: "groupId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _unref(searchModel).groupId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchModel).groupId) = $event)),
                style: {"width":"220px"},
                onChange: selectGroup,
                placeholder: _unref(langObj)['选择设备区域']
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: index,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['设备'],
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _unref(searchModel).machineId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchModel).machineId) = $event)),
                placeholder: _unref(langObj)['选择设备'],
                style: {"width":"220px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineList), (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: index,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['更新时间'],
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _unref(searchModel).date,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchModel).date) = $event)),
                "disabled-date": disabledDate,
                onCalendarChange: onCalendarChange
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['严重程度'],
            name: "grade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _unref(searchModel).grade,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchModel).grade) = $event)),
                style: {"width":"220px"},
                placeholder: _unref(langObj)['选择严重程度']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "0" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['可用']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['警戒']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['故障']), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _unref(langObj)['搜索'],
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                style: {"width":"220px"},
                placeholder: _unref(langObj)['请输入关键词搜索'],
                value: _unref(searchModel).keyword,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchModel).keyword) = $event))
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  onClick: reset,
                  class: "btn px-5 py-1 fff cursor-pointer ml-4"
                }, _toDisplayString(_unref(langObj)['重置']), 1),
                _createElementVNode("div", {
                  onClick: search,
                  class: "btn px-5 py-1 fff cursor-pointer ml-4",
                  style: {"background-color":"#171325ff"}
                }, _toDisplayString(_unref(langObj)['查询']), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_table, {
        style: {"width":"100%"},
        size: "small",
        "row-class-name": getRowClassName,
        columns: columns,
        "data-source": _unref(data),
        pagination: pagination.value,
        onChange: handleTableChange
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.dataIndex === 'groupName')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(getTranslation)(text)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.dataIndex === 'machineName')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(getTranslation)(text)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.dataIndex === 'gradeText')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"12px","height":"12px","border-radius":"50%","margin-right":"5px"}, {'background':  _unref(gradeList).find(p => p.value === text)?.color}])
                }, null, 4),
                _createElementVNode("span", null, _toDisplayString(_unref(langObj)[_unref(gradeList).find(p => p.value === text)?.label ]), 1)
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex === 'content')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_unref(language)==='Chinese_ft')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getChineseFt)(text)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(getDiagLang)(text)), 1))
              ], 64))
            : _createCommentVNode("", true),
          (column.dataIndex === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_unref(transformLocalDate)(text)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.dataIndex === 'act')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (details(record)),
                  style: {"color":"#00d1c7ff !important"}
                }, _toDisplayString(_unref(langObj)['查看详情']), 9, _hoisted_7),
                _createVNode(_component_a_divider, { type: "vertical" }),
                (_unref(admin))
                  ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                      key: 0,
                      title: _unref(langObj)['确认删除']+'?',
                      "ok-text": _unref(langObj)['确认'],
                      "cancel-text": _unref(langObj)['取消'],
                      onConfirm: ($event: any) => (deleteReport(record))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(langObj)['删除']), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"])
    ]),
    _createVNode(_component_a_drawer, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
      class: "custom-class",
      size: "large",
      closable: false,
      placement: "right"
    }, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [])),
      default: _withCtx(() => [
        _createVNode(DiagnosticReportDetails, {
          ref_key: "mrDref",
          ref: mrDref,
          reportId: _unref(reportId),
          onCancel: cancel
        }, null, 8, ["reportId"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})